export default "__VITE_ASSET__DeLxB_FZ__"